<template>
    <div>
        <h2>
            #{{ model.order_number }}
            <small class="order__time">{{ model.ordered_on | datetime }}</small>
        </h2>

        <el-row :gutter="30">
            <el-col :xs="24" :sm="16">
                <div v-if="model.order_items">
                    <el-table
                        :data="model.order_items"
                        stripe
                        v-if="hasSku"
                        style="width: 100%"
                    >
                        <el-table-column prop="image" label="Image">
                            <template slot-scope="scope">
                                <div v-if="scope.row.image">
                                    <img :src="scope.row.image" width="40" />
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="sku" label="Name">
                            <template slot-scope="scope">
                                <div v-if="scope.row">
                                    <span
                                        v-if="
                                            scope.row.meta_data &&
                                            scope.row.meta_data.name
                                        "
                                        >{{ scope.row.meta_data.name }}<br
                                    /></span>
                                    <span class="label-lg">{{
                                        scope.row.sku
                                    }}</span>
                                    <div
                                        class="mt-5"
                                        v-if="
                                            scope.row.selected_products &&
                                            scope.row.meta_data &&
                                            scope.row.meta_data.properties &&
                                            isDynamicPackage(
                                                scope.row.meta_data.properties
                                            )
                                        "
                                    >
                                        <strong>Included products:</strong>
                                        <div
                                            v-for="(
                                                selectedProduct, index
                                            ) in scope.row.selected_products"
                                            :key="selectedProduct.id + index"
                                        >
                                            <span>{{
                                                selectedProduct.name
                                            }}</span
                                            ><br /><span class="label-lg">{{
                                                selectedProduct.sku
                                            }}</span>
                                        </div>
                                    </div>
                                    <div
                                        class="mt-5"
                                        v-if="
                                            scope.row.selected_products &&
                                            scope.row.meta_data &&
                                            scope.row.meta_data.properties &&
                                            isDynamicPricePackage(
                                                scope.row.meta_data.properties
                                            )
                                        "
                                    >
                                        <strong>Included products:</strong>
                                        <div
                                            v-for="(
                                                selectedProduct, index
                                            ) in scope.row.selected_products"
                                            :key="selectedProduct.id + index"
                                        >
                                            {{ selectedProduct.name }} ({{
                                                selectedProduct.price
                                                    | currency(
                                                        selectedProduct.currency +
                                                            ' '
                                                    )
                                            }})
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="price" label="Price">
                            <template slot-scope="scope">
                                <div v-if="scope.row && scope.row.value">
                                    {{
                                        scope.row.value
                                            | currency(model.currency + ' ')
                                    }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="quantity"
                            label="Quantity"
                            width="120"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="total_price"
                            label="Total"
                            width="180"
                        >
                            <template slot-scope="scope">
                                <div v-if="scope.row">
                                    <div
                                        v-if="
                                            scope.row.meta_data &&
                                            scope.row.meta_data.properties &&
                                            isDynamicPricePackage(
                                                scope.row.meta_data.properties
                                            )
                                        "
                                    >
                                        <div
                                            v-if="
                                                scope.row.total_value &&
                                                scope.row.discount
                                            "
                                        >
                                            {{
                                                (scope.row.total_value -
                                                    Math.abs(
                                                        scope.row.discount
                                                    ))
                                                    | currency(
                                                        model.currency + ' '
                                                    )
                                            }}
                                        </div>
                                        <div
                                            v-if="scope.row.total_value"
                                            class="text-zinc-400"
                                        >
                                            <del>{{
                                                scope.row.total_value
                                                    | currency(
                                                        model.currency + ' '
                                                    )
                                            }}</del>
                                        </div>
                                        <div v-if="scope.row.discount">
                                            <strong>Your savings:</strong
                                            ><br />{{
                                                Math.abs(scope.row.discount)
                                                    | currency(
                                                        model.currency + ' '
                                                    )
                                            }}
                                        </div>
                                    </div>
                                    <div v-else-if="scope.row.total_value">
                                        {{
                                            scope.row.total_value
                                                | currency(model.currency + ' ')
                                        }}
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-table
                        :data="model.order_items"
                        stripe
                        style="width: 100%"
                        v-if="!hasSku"
                    >
                        <el-table-column prop="meta_data" label="Product Info">
                            <template slot-scope="scope">
                                <div v-if="scope.row.contents">
                                    {{ scope.row.contents.sku }} -
                                    {{ scope.row.contents.name }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="price" label="Price">
                        </el-table-column>
                        <el-table-column
                            prop="quantity"
                            label="Quantity"
                            width="180"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="total_price"
                            label="Total"
                            width="180"
                        >
                        </el-table-column>
                    </el-table>
                </div>

                <div class="el-table">
                    <div class="el-table__footer-wrapper">
                        <table
                            cellspacing="0"
                            cellpadding="0"
                            border="0"
                            class="el-table__footer"
                        >
                            <tbody>
                                <tr>
                                    <td class="is-leaf">
                                        <div class="cell text-right">
                                            Subtotal
                                        </div>
                                    </td>
                                    <td class="is-leaf" width="180">
                                        <div class="cell">
                                            {{
                                                model.subtotal
                                                    | currency(
                                                        model.currency + ' '
                                                    )
                                            }}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="is-leaf">
                                        <div class="cell text-right">
                                            Shipping
                                        </div>
                                    </td>
                                    <td class="is-leaf" width="180">
                                        <div class="cell">
                                            {{
                                                model.shipping
                                                    | currency(
                                                        model.currency + ' '
                                                    )
                                            }}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="is-leaf">
                                        <div class="cell text-right">
                                            Discount
                                        </div>
                                    </td>
                                    <td class="is-leaf" width="180">
                                        <div class="cell">
                                            {{
                                                model.coupon_discount
                                                    | currency(
                                                        model.currency + ' '
                                                    )
                                            }}
                                        </div>
                                    </td>
                                </tr>
                                <tr
                                    v-if="
                                        model.applied_coupons &&
                                        model.applied_coupons.length
                                    "
                                >
                                    <td class="is-leaf">
                                        <div class="cell text-right">
                                            Applied coupons
                                        </div>
                                    </td>
                                    <td class="is-leaf" width="180">
                                        <div class="cell">
                                            <div
                                                v-for="coupon in model.applied_coupons"
                                                :key="coupon.id"
                                            >
                                                {{ coupon.name }} (ID:
                                                {{ coupon.id }})
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="is-leaf">
                                        <div class="cell text-right">Tax</div>
                                    </td>
                                    <td class="is-leaf" width="180">
                                        <div class="cell">
                                            {{
                                                model.tax
                                                    | currency(
                                                        model.currency + ' '
                                                    )
                                            }}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="is-leaf">
                                        <div class="cell text-right">Total</div>
                                    </td>
                                    <td class="is-leaf" width="180">
                                        <div class="cell">
                                            {{
                                                model.total
                                                    | currency(
                                                        model.currency + ' '
                                                    )
                                            }}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div>
                    <h4 class="order__subhead">History</h4>
                    <div v-if="!model.histories || !model.histories.length">
                        No history yet
                    </div>
                    <el-table :data="model.histories" style="width: 100%">
                        <el-table-column label="Date" prop="created_at">
                            <template slot-scope="scope">
                                {{ scope.row.created_at | datetime }}
                            </template>
                        </el-table-column>
                        <el-table-column label="Action" prop="action">
                        </el-table-column>
                    </el-table>

                    <h4 class="order__subhead">Payments</h4>
                    <div v-if="!model.payments || !model.payments.length">
                        No payments yet
                    </div>
                    <el-table :data="model.payments" style="width: 100%">
                        <el-table-column label="Date" prop="created_at">
                            <template slot-scope="scope">
                                {{ scope.row.created_at | datetime }}
                            </template>
                        </el-table-column>
                        <el-table-column label="Status" prop="status">
                        </el-table-column>
                        <el-table-column label="Module" prop="module">
                        </el-table-column>
                    </el-table>
                </div>
            </el-col>
            <el-col :xs="24" :sm="8">
                <dl class="dl">
                    <dt>Status</dt>
                    <dd>
                        <v-crud-select
                            class="order__full"
                            :options="statuses"
                            :value="model.status"
                            @input="onChangeInput"
                        ></v-crud-select>
                    </dd>
                    <dt>Shipping method</dt>
                    <dd class="text-sm">{{ model.shipping_method_name }}</dd>
                    <dt>Tracking number</dt>
                    <dd>
                        <el-input
                            class="order__full"
                            v-model="model.tracking_number"
                        ></el-input>
                    </dd>
                    <template v-if="isVisible">
                        <dt>Business Partner ID (End User)</dt>
                        <dd>
                            <el-input
                                class="order__full"
                                v-model="model.ext_id"
                            ></el-input>
                        </dd>
                    </template>
                    <template v-if="showInvoice">
                        <dt>Invoice number</dt>
                        <dd>
                            <el-input
                                class="order__full"
                                v-model="model.notes"
                            ></el-input>
                        </dd>
                    </template>
                    <dd>
                        <el-button
                            type="primary"
                            class="order__full"
                            @click="save"
                            >Save</el-button
                        >
                    </dd>
                    <template v-if="showInvoice">
                        <dd>
                            <el-button
                                v-loading="invoiceLoading"
                                type="primary"
                                class="order__full"
                                @click="getInvoicePdf"
                                >Download invoice</el-button
                            >
                        </dd>
                    </template>
                    <template v-if="showInvoice">
                        <dd>
                            <el-button
                                v-loading="sendInvoiceLoading"
                                type="primary"
                                class="order__full"
                                @click="sendInvoicePdf"
                                >Send invoice via e-mail</el-button
                            >
                        </dd>
                    </template>
                    <dt>Email</dt>
                    <dd class="text-sm">{{ model.email }}</dd>
                    <dt>Address</dt>
                    <dd class="text-sm" v-if="model.ship_address">
                        <span
                            @click="goToCustomer"
                            class="el-button--text cursor-pointer"
                        >
                            {{ model.ship_address.firstname }}
                            {{ model.ship_address.lastname }}
                        </span>
                        <br />
                        {{ model.ship_address.address1 }}
                        {{ model.ship_address.address2 }}<br />
                        {{ model.ship_address.zip }} {{ model.ship_address.city
                        }}<br />
                        {{ model.ship_address.country }}
                    </dd>
                    <dt>Shipping Notes</dt>
                    <dd class="text-sm" v-if="model.shipping_notes">
                        <ul>
                            <li v-for="(value, key) in model.shipping_notes">
                                <em>{{ key }}:</em> {{ value }}
                            </li>
                        </ul>
                    </dd>
                    <dd>
                        <el-button
                            type="primary"
                            class="order__full"
                            @click="goToCustomer"
                            >Edit Customer</el-button
                        >
                    </dd>
                </dl>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import Select from './fields/Select.vue';
import api from '../libs/api';
import download from '../libs/download';

export default {
    name: 'order_detail',
    props: ['model', 'rootConfig', 'siteId', 'permittedSitesConfig'],

    data() {
        return {
            statuses: [
                { value: 'Open', label: 'Open' },
                { value: 'Pending', label: 'Pending' },
                { value: 'Processing', label: 'Processing' },
                { value: 'Shipped', label: 'Shipped' },
                { value: 'On Hold', label: 'On Hold' },
                { value: 'Cancelled', label: 'Cancelled' },
                { value: 'Not Payed', label: 'Not Payed' },
                { value: 'Returned', label: 'Returned' },
                { value: 'Delivered', label: 'Delivered' },
            ],
            customer_id: null,
            showInvoice: false,
            invoiceCustomer: '',
            invoiceToken: '',
            invoiceLoading: false,
            sendInvoiceLoading: false,
            invoiceEmailEndpoint: undefined,
        };
    },

    components: {
        'v-crud-select': Select,
    },

    computed: {
        isVisible() {
            let site_id = this.siteId;

            if (Object.hasOwn(this.permittedSitesConfig, site_id)) {
                site_id = this.permittedSitesConfig[`${site_id}`];
            }

            return Object.values(this.permittedSitesConfig).includes(
                Number(site_id)
            );
        },
        hasSku() {
            if (
                this.model &&
                this.model.order_items &&
                this.model.order_items[0].sku !== null
            ) {
                return true;
            }
            return false;
        },

        apiResource() {
            return this.$resource(
                this.rootConfig.endPoint + '/customers',
                {},
                {},
                { headers: this.rootConfig.headers }
            );
        },
    },

    created() {
        // Check settings for invoice
        const apiResource = this.$resource(
            this.rootConfig.endPoint + '/settings?per_page=500',
            {},
            {},
            { headers: this.rootConfig.headers }
        );

        apiResource
            .get()
            .then((res) => {
                res.data.forEach((setting) => {
                    if (
                        setting.code === 'general_setting' &&
                        setting.setting_key === 'order_invoice' &&
                        setting.setting === '1'
                    ) {
                        this.showInvoice = true;
                    }

                    if (
                        setting.code === 'general_setting' &&
                        setting.setting_key === 'order_invoice_customer'
                    ) {
                        this.invoiceCustomer = setting.setting;
                    }

                    if (
                        setting.code === 'general_setting' &&
                        setting.setting_key === 'order_invoice_token'
                    ) {
                        this.invoiceToken = setting.setting;
                    }

                    if (
                        setting.code === 'general_setting' &&
                        setting.setting_key === 'invoice_email_endpoint'
                    ) {
                        this.invoiceEmailEndpoint = setting.setting;
                    }
                });
            })
            .catch(api.errorHandler);
    },

    methods: {
        onChangeInput(value) {
            this.model.status = value;
            this.save();
            const tabMessages = document.getElementById('tab-1');
            if (tabMessages) {
                setTimeout(() => tabMessages.click(), 500);
            }
        },
        isDynamicPackage(properties) {
            return (
                properties.filter(
                    (property) => property.slug === 'dynamicPackage'
                ).length > 0
            );
        },
        isDynamicPricePackage(properties) {
            return (
                properties.filter(
                    (property) => property.slug === 'dynamicPricePackage'
                ).length > 0
            );
        },
        goToCustomer() {
            this.$router.push({
                name: 'admin',
                params: {
                    id: this.model.customer_id,
                    action: 'edit',
                    model: 'customers',
                },
            });
        },
        save() {
            api.res
                .update({ id: this.model.id }, this.model)
                .then(() => {
                    this.$message('Updated successfully');
                })
                .catch(api.errorHandler);
        },
        async getInvoicePdf() {
            this.invoiceLoading = true;
            const url = `https://pdf-service.netural.com/render/${this.model.language}/${this.invoiceCustomer}/invoice?token=${this.invoiceToken}`;

            const taxRates = await this.getTaxRates();

            const data = {
                order: this.model,
                tax_rates: taxRates,
            };

            this.$http.post(url, data, { responseType: 'blob' }).then(
                (res) => {
                    download(
                        res.data,
                        `${this.invoiceCustomer}-invoice-${this.model.order_number}.pdf`,
                        'application/pdf'
                    );
                    this.invoiceLoading = false;
                    console.log(res);
                },
                (err) => {
                    this.invoiceLoading = false;
                    console.log(err);
                    api.errorHandler.call(this, err);
                }
            );
        },
        async sendInvoicePdf() {
            if (this.invoiceEmailEndpoint) {
                const taxRates = await this.getTaxRates();

                this.sendInvoiceLoading = true;

                const postData = {
                    order: this.model,
                    tax_rates: taxRates,
                };

                this.$http
                    .post(this.invoiceEmailEndpoint, postData, {
                        headers: this.rootConfig.headers,
                    })
                    .then((res) => {
                        this.$message({
                            message: 'Message sent successfully',
                            type: 'success',
                        });
                        this.sendInvoiceLoading = false;
                    })
                    .catch((error) => {
                        this.sendInvoiceLoading = false;
                        this.$message({
                            message: 'Oh no! Sending the invoice failed.',
                            type: 'error',
                        });
                        console.log(error);
                    });
            }
        },
        getTaxRates() {
            return new Promise((resolve) => {
                const apiResource = this.$resource(
                    this.rootConfig.endPoint + '/tax_rates',
                    {},
                    {},
                    { headers: this.rootConfig.headers }
                );

                apiResource
                    .get()
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch(api.errorHandler);
            });
        },
    },
};
</script>

<style scoped>
.mt-5 {
    margin-top: 20px;
}

.text-zinc-400 {
    color: rgb(161 161 170);
}

.button--link {
    background-color: transparent;
    border: none;
    padding: 0;
}

.order__full {
    width: 100%;
}

.order__subhead {
    margin-bottom: 5px;
}

.text-right {
    text-align: right;
}

.order__time {
    color: #99a9bf;
}

.dl {
    margin: 0;
}

.dl dt {
    margin-bottom: 5px;
    font-weight: bold;
}

.dl dd {
    margin: 0;
    line-height: 1;
    margin-bottom: 20px;
}

.dl ul {
    margin: 0;
}

.el-table table {
    width: 100%;
}

.label-lg {
    background-color: #b3b3b3;
    border-radius: 0.25em;
    color: #fff;
    display: inline;
    font-size: 75%;
    padding: 0.3em 0.6em;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// Order.vue?db7ab908